import { IPublicClientApplication } from "@azure/msal-browser";

import {
    axiosDelRequest,
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../../api/ApiClient";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/calendariogestaoatividades";

function getActivityManagementDateById(
    id: number | undefined,
    instance: IPublicClientApplication
) {
    return axiosGetRequest(
        `${route}/${id}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function getActivityManagementDateByDate(
    dataRange: string | null,
    instance: IPublicClientApplication
) {
    const params = StringUtils.getQueryParams({
        dataRange,
    });

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function createActivityManagementDate(
    dates: object,
    instance: IPublicClientApplication
) {
    return axiosPostRequest(
        `${route}`,
        dates,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function editActivityManagementDate(
    id: number,
    dates: object,
    instance: IPublicClientApplication
) {
    return axiosPutRequest(
        `${route}/${id}`,
        dates,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

function deleteActivityManagementDate(
    id: number | undefined,
    instance: IPublicClientApplication
) {
    return axiosDelRequest(
        `${route}/${id}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getActivityManagementDateById,
    getActivityManagementDateByDate,
    createActivityManagementDate,
    editActivityManagementDate,
    deleteActivityManagementDate,
};
